import {QueryClient} from '@tanstack/react-query'

/**
 * 앱 전역 QueryClient.
 * 점진적 도입 단계라 우선 flagged-review 페이지에서만 사용.
 * 기존 axios 수동 패칭과 공존하며, 사용처가 늘어나면 defaultOptions를 조정한다.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 1000 * 30,
    },
  },
})
